import PropTypes from "prop-types";
import { NavLink as RouterLink, useLocation } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Link, Stack } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const LinkStyle = styled(Link)(({ theme }) => ({
  ...theme.typography.subtitle1,
  textDecoration: "none",
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shortest,
  }),
  "&:hover": {
    opacity: 0.48,
    textDecoration: "none",
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

MenuDesktopItem.propTypes = {
  item: PropTypes.object,
  pathname: PropTypes.string,
  isDark: PropTypes.bool,
};

function MenuDesktopItem({ item, pathname, isDark }) {
  const { title, path } = item;
  const isActive = pathname === path;

  return (
    <LinkStyle
      to={path}
      component={RouterLink}
      sx={{
        color: isDark ? "text.primary" : "text.secondary",
        ...(isActive && { color: "primary.main" }),
        mr: { md: 2, lg: 3, xl: 4, xxl: 5 },
        fontWeight: 500,
      }}
    >
      {title !== "Home" ? (
        title
      ) : (
        <HomeIcon
          sx={{
            fontSize: { md: 28, lg: 32, xl: 36, xxl: 40 },
            color: isDark ? "text.primary" : "text.secondary",
            ...(isActive && { color: "primary.main" }),
          }}
        />
      )}
    </LinkStyle>
  );
}

MenuDesktop.propTypes = {
  navConfig: PropTypes.array,
};

export default function MenuDesktop({ navConfig, isDark }) {
  const { pathname } = useLocation();

  return (
    <Stack direction="row" alignItems="center">
      {navConfig.map((link) => (
        <MenuDesktopItem
          key={link.title}
          item={link}
          pathname={pathname}
          isDark={isDark}
        />
      ))}
    </Stack>
  );
}
